import { BlogSection } from "@/types/blog";

export const intro: BlogSection = {
  id: "intro",
  title: "Einleitung",
  content: `
    <p>Seit Tagen kratzt der Hals, die Stimme klingt rau, die Energie sinkt. Der Körper zieht die Handbremse.</p>
    
    <p>Früher wäre die Reaktion eindeutig gewesen: durchziehen. Ibu, Kaffee, Terminkalender durchhalten, koste es, was es wolle.</p>
    
    <p>Heute höre ich anders hin. Denn das, was früher als Schwäche galt, ist aus neurobiologischer Sicht oft das Gegenteil: ein hochpräzises Signal. Das Nervensystem hat entschieden, dass Regeneration jetzt Vorrang hat. Und es weiß das oft früher als unser Verstand.</p>
    
    <p>Diese Erfahrung teilen viele, ob im Berufsleben, im Coaching oder im Alltag. Der Körper meldet sich, wenn mentale Selbststeuerung überzieht. Und je besser wir verstehen, was dabei geschieht, desto bewusster können wir führen. Uns selbst, und indirekt auch andere.</p>
  `
};
